import { colorPalette } from "@/themes";

const getSideNavColors = (theme) => {
    const isDark = theme.palette.mode == "dark";

    return {
        active: isDark
            ? colorPalette.green.dark.main
            : colorPalette.green.light.main,
        background: isDark ? colorPalette.black : colorPalette.white,
        border: isDark
            ? colorPalette.grey.dark.two
            : colorPalette.grey.light.two,
        divider: isDark
            ? colorPalette.grey.dark.two
            : colorPalette.grey.light.two,
        dropdownBackground: isDark
            ? colorPalette.grey.dark.three
            : colorPalette.grey.light.three,
        dropdownShadow: isDark
            ? "0px 4px 50px rgba(0, 0, 0, 0.25)"
            : "0px 4px 50px rgba(0, 0, 0, 0.12)",
        floatingSurface: isDark
            ? colorPalette.grey.dark.three
            : colorPalette.grey.light.three,
        hoverBackground: isDark
            ? colorPalette.grey.dark.three
            : colorPalette.grey.light.three,
        hoverText: isDark ? colorPalette.white : colorPalette.black,
        indicator: isDark ? colorPalette.white : colorPalette.black,
        mobileBackground: isDark ? colorPalette.black : colorPalette.white,
        navText: isDark
            ? colorPalette.grey.light.one
            : colorPalette.grey.dark.two,
        orgHoverBackground: isDark
            ? colorPalette.grey.dark.three
            : colorPalette.grey.light.three,
        orgOptionHoverBackground: isDark
            ? colorPalette.grey.dark.two
            : colorPalette.grey.light.two,
        orgTitle: isDark ? "#FFFFFF" : colorPalette.black,
        subtitle: colorPalette.universalGrey,
        tooltipBackground: isDark
            ? colorPalette.grey.dark.three
            : colorPalette.grey.light.three,
        indicatorTooltipBackground: isDark
            ? colorPalette.grey.dark.one
            : colorPalette.grey.light.three,
        tooltipText: isDark ? "#FFFFFF" : colorPalette.black,
        avatarBackground: isDark
            ? colorPalette.grey.dark.one
            : colorPalette.grey.light.one,
        teamAvatarBackground: isDark
            ? colorPalette.grey.dark.two
            : colorPalette.grey.light.two,
        activeBadgeBackground: isDark
            ? colorPalette.green.dark.three
            : colorPalette.green.light.three,
        activeBadgeText: isDark
            ? colorPalette.green.light.one
            : colorPalette.green.dark.one,
    };
};

export { getSideNavColors };
